export type DeleteFormData = {
  reason: {
    state: "pristine" | "touched" | "invalid" | "valid";
    value: string;
  };
  file?: {
    value: File;
    state: string;
    message?: string;
  };
};

export const INITIAL_FORM_DATA: DeleteFormData = {
  reason: { state: "pristine", value: "" },
  file: undefined,
};
